import React from 'react';
import Profile, { ProfileCardProps } from 'Components/Card/Profile';
import { PaginationProps } from 'Components/Pagination';

import { List, ListItem, NoResults, PaginationWrapper, StyledPagination } from './Staff.styled';

export interface Props {
    items: (ProfileCardProps & { id: string })[];
    pagination: PaginationProps;
}

const Staff: React.FC<Props> = props => {
    const { items, pagination } = props;

    return (
        <>
            <List>
                {items.length > 0 ? (
                    items.map(profile => (
                        <ListItem key={profile.id}>
                            <Profile {...profile} />
                        </ListItem>
                    ))
                ) : (
                    <NoResults>No results found</NoResults>
                )}
            </List>
            {items.length > 0 && (
                <PaginationWrapper>
                    <StyledPagination {...pagination} />
                </PaginationWrapper>
            )}
        </>
    );
};

export default Staff;
